<template>
    <v-card class="background-2" elevation="0" v-if="tokens.length > 0">
        <v-card-title class="pa-3">
            <p>Authorized Applications</p>
        </v-card-title>

        <v-card-text class="px-0">
            <v-data-table
                :headers="headers"
                :items="tokens"
                :items-per-page="5"
                class="elevation-0 background-2"
                :mobile-breakpoint="0"
                :footer-props="{
                    'items-per-page-options': [5, 10, 25, 50,  { text: 'Tutti', value: -1 }],
                    showFirstLastPage: true
                }">
                <template v-slot:item.actions="{ item }">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on"
                                icon
                                small
                                class="mx-0"
                                @click.stop="revoke(item)">
                                <v-icon color="red">mdi-delete</v-icon>
                            </v-btn>
                        </template>
                        <span>Revoca</span>
                    </v-tooltip>
                </template>

                <template
                    v-slot:item.name="{ item }">
                    {{ item.client.name }}
                </template>

                <template
                    v-slot:item.scopes="{ item }">
                    {{ item.scopes.join(', ') }}
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>

<script>

    export default {
        data() {
            return {
                tokens: [],
                headers: [
                    { text: 'Azioni', value: 'actions', sortable: false },
                    { text: 'Nome', value: 'name' },
                    { text: 'Scopes', value: 'scopes' },
                ]
            };
        },

        mounted() {
            this.getTokens()
        },

        methods: {

            getTokens() {
                this.axios.get('/oauth/tokens').then(response => {
                    this.tokens = response.data
                })
            },

            revoke(token) {
                this.axios.delete('/oauth/tokens/' + token.id).then(response => {
                    this.getTokens()
                })
            }
        }
    }
</script>
